<div class="listview-header">
  <div class="row">
    <div class="col-3">
      <base-checkbox
        *ngIf="!isWorkCouncil"
        [isChecked]="allSelected"
        [isDisabled]="isListEmpty"
        (getChange)="onAllSelected($event)"
        label="name"
        [tooltip]="(allSelected ? 'inquiry.deselectAll' : 'inquiry.selectAll') | translate"
        checkboxClasses="checkbox-shadow"
      ></base-checkbox>
      <span *ngIf="isWorkCouncil">{{ 'name' | translate }}</span>
    </div>
    <div
      class="col-2"
      baseTruncate
    >
      {{ 'provider' | translate }}
    </div>
    <div
      class="col-3"
      baseTruncate
    >
      {{ 'externalEmployees.departmentAndLocation' | translate }}
    </div>
    <div class="col-2">
      <base-sortable-headline-item
        label="operations.singular"
        [orderKey]="orderKeys.startDate"
      ></base-sortable-headline-item>
    </div>
  </div>
</div>
